import { SVGProps } from 'react'

export const NeStyleSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 14 14' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8.563.75c.986 0 1.794.761 1.869 1.728l.002.084h.941c.986 0 1.795.762 1.87 1.729l.005.146v6.938c0 .986-.761 1.795-1.728 1.87l-.147.005H4.437a1.875 1.875 0 0 1-1.869-1.728l-.006-.147v-.941l-.084-.002A1.875 1.875 0 0 1 .756 8.709L.75 8.563V2.625c0-.986.761-1.795 1.728-1.87L2.625.75h5.938Zm.398 9.645L10.565 12l.81.001a.625.625 0 0 0 .618-.533l.007-.092v-.38l-1.707-1.708a1.879 1.879 0 0 1-1.332 1.108Zm-4.268.042h-.881v.938c0 .314.232.574.533.618l.093.007h1.817l-1.562-1.563Zm3.249 0H5.753L7.316 12h2.19l-1.564-1.563Zm2.495-4.255v2.189L12 9.934v-2.19l-1.563-1.562ZM8.563 2H2.625a.625.625 0 0 0-.618.533L2 2.625v5.938c0 .313.231.573.533.618l.03.002.062.005 1.877-.001h4.061a.625.625 0 0 0 .618-.532l.007-.092V2.625A.625.625 0 0 0 8.562 2Zm1.874 1.812v1.309L12 6.684V4.437a.625.625 0 0 0-.533-.618l-.092-.006-.938-.001Z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  )
}
